export const GET_ALL_USER = 'GET_ALL_USER';
export const GET_USER = 'GET_USER';
export const UPDATE_SINGLE_USER = 'UPDATE_SINGLE_USER';
export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';
export const GET_ALL_USER_SUCCESS = 'GET_ALL_USER_SUCCESS';
export const GET_ALL_USER_ERROR = 'GET_ALL_USER_ERROR';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_ERROR = 'GET_USER_ERROR';
export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR';

// update_user_general
export const UPDATE_USER_GENERAL = 'update_user_general';
export const UPDATE_USER_GENERAL_SUCCESSFUL = 'update_user_general_successfull';
export const UPDATE_USER_GENERAL_FAILED = 'update_user_general_failed';

// update_user_work_exprience
export const UPDATE_USER_WORK_EXPRIENCE = 'update_user_work_exprience';
export const UPDATE_USER_WORK_EXPRIENCE_SUCCESSFUL =
  'update_user_work_exprience_successfull';
export const UPDATE_USER_WORK_EXPRIENCE_FAILED =
  'update_user_work_exprience_failed';

// update_user_education
export const UPDATE_USER_EDUCATION = 'update_user_education';
export const UPDATE_USER_EDUCATION_SUCCESSFUL =
  'update_user_education_successfull';
export const UPDATE_USER_EDUCATION_FAILED = 'update_user_education_failed';

// get_socials
export const GET_SOCIALS = 'get_socials';
export const GET_SOCIALS_SUCCESSFUL = 'get_socials_successfull';
export const GET_SOCIALS_FAILED = 'get_socials_failed';

// update_user_social_media
export const UPDATE_USER_SOCIAL_MEDIA = 'update_user_social_media';
export const UPDATE_USER_SOCIAL_MEDIA_SUCCESSFUL =
  'update_user_social_media_successfull';
export const UPDATE_USER_SOCIAL_MEDIA_FAILED =
  'update_user_social_media_failed';

// get_goals
export const GET_GOALS = 'get_goals';
export const GET_GOALS_SUCCESSFUL = 'get_goals_successfull';
export const GET_GOALS_FAILED = 'get_goals_failed';

// update_user_goals
export const UPDATE_USER_GOALS = 'update_user_goals';
export const UPDATE_USER_GOALS_SUCCESSFUL = 'update_user_goals_successfull';
export const UPDATE_USER_GOALS_FAILED = 'update_user_goals_failed';

// get_basic_type_categories
export const GET_BASIC_TYPE_CATEGORIES = 'get_basic_type_categories';
export const GET_BASIC_TYPE_CATEGORIES_SUCCESSFUL =
  'get_basic_type_categories_successfull';
export const GET_BASIC_TYPE_CATEGORIES_FAILED =
  'get_basic_type_categories_failed';

// get_basic_types
export const GET_BASIC_TYPES = 'get_basic_types';
export const GET_BASIC_TYPES_SUCCESSFUL = 'get_basic_types_successfull';
export const GET_BASIC_TYPES_FAILED = 'get_basic_types_failed';

// update_user_interests
export const UPDATE_USER_INTERESTS = 'update_user_interests';
export const UPDATE_USER_INTERESTS_SUCCESSFUL =
  'update_user_interests_successfull';
export const UPDATE_USER_INTERESTS_FAILED = 'update_user_interests_failed';

// update_user_role_profiles
export const UPDATE_USER_ROLE_PROFILES = 'update_user_role_profiles';
export const UPDATE_USER_ROLE_PROFILES_SUCCESSFUL =
  'update_user_role_profiles_successfull';
export const UPDATE_USER_ROLE_PROFILES_FAILED =
  'update_user_role_profiles_failed';
